{
  "account": {
    "title": "Minha conta",
    "list": {
      "title": "Contas",
      "description": "Lista de faturas de contas vinculadas"
    },
    "form": {
      "name": {
        "title": "Nome",
        "description": "Nome da sua conta"
      },
      "password": {
        "title": "Senha",
        "description": "Defina uma nova senha para sua conta; deixe em branco para manter a senha atual"
      },
      "emailPreferences": {
        "title": "Preferências de e-mail",
        "description": "Selecione os tipos de notificação por e-mail"
      }
    },
    "billing": "Detalhes de cobrança",
    "subscriptions": "Assinaturas",
    "manageSubscription": "Gerenciar assinatura",
    "popup": {
      "cancel": "Tem certeza de que deseja cancelar sua assinatura?<br/>Seu site continuará sendo traduzido até o final do período atual. Após isso, a tradução será desativada.<br/>Observe que você não terá direito a reembolso pelo período não utilizado.",
      "downgrade": "Tem certeza de que deseja fazer downgrade? A mudança será efetivada imediatamente.<br/>Observe que você não terá direito a reembolso pelo tempo restante do ciclo de faturamento atual.<br/>O novo valor do plano será aplicado no próximo ciclo de cobrança.",
      "default": "Tem certeza de que deseja alterar seu plano?",
      "resume": "Tem certeza de que deseja reativar sua assinatura?"
    }
  },
  "ai_translation": {
    "header": "Tradução por IA",
    "plan": {
      "header": "Preços da Tradução por IA",
      "used": "Você usou {words_used} / {words_allowed} palavras traduzidas em seus créditos de IA.",
      "remaining": "Créditos de IA disponíveis:",
      "words": "palavras",
      "add_more_credits": "Adicionar mais créditos de IA",
      "details": {
        "idiomatic_expressions": "Expressões idiomáticas e técnicas",
        "background_translation": "Traduções em segundo plano",
        "best_website": "Sites que exigem tradução de qualidade perfeita",
        "page_context": "Contexto da página e do site para tradução",
        "perfect_quality": "Qualidade perfeita, preço acessível",
        "no_recurring": "Sem pagamento recorrente, cota pré-paga",
        "save_40": "Economize 40% em comparação ao plano de US$ 20",
        "save_50": "Economize 50% em comparação ao plano de US$ 20"
      },
      "quota": "{estimated_words} palavras ~ {estimated_pages} páginas"
    },
    "settings": {
      "banner": {
        "title": "Tradução por IA da Linguise",
        "intro": "A Linguise tem o prazer de apresentar a Tradução por IA da Linguise, um novo recurso premium que utiliza modelos de IA LLM (modelos recentes do Llama, otimizados para tarefas de tradução). Projetada para sites que exigem perfeição, ela considera o contexto da página inteira e do site para resultados sem precedentes. Ofereça aos seus clientes o ápice da qualidade de tradução, garantindo que sua mensagem ressoe perfeitamente em todos os idiomas.",
        "button": "Atualize agora"
      },
      "alert": {
        "description": "Este recurso não está incluído em seu plano atual e requer compra separada.\nAtive este complemento para desbloquear todas as opções listadas abaixo."
      },
      "languages": {
        "title": "Aplicar tradução por IA aos idiomas",
        "description": "Selecione idiomas específicos onde deseja aplicar a tradução por IA"
      },
      "button": {
        "save": "Salvar configurações"
      },
      "form": {
        "advanced": {
          "title": "Instruções avançadas de IA",
          "description": "Instruções avançadas de IA"
        },
        "enable_mode": {
          "title": "ATIVAR TRADUÇÃO POR IA",
          "description": "Escolha como deseja ativar a tradução por IA.\nApenas regras aplicará as regras a seguir.\nSomente editor ao vivo permitirá ativar a tradução página por página na visualização do editor ao vivo.\nRegras e editor ao vivo usarão ambos os recursos.",
          "disabled": "Desativado",
          "rules": "Apenas regras",
          "live_editor": "Somente editor ao vivo",
          "all": "Regras e editor ao vivo"
        },
        "rule_application": {
          "description": "Aplicar a Tradução por IA ao conteúdo estático, dinâmico ou ambos",
          "title": "Aplicar ao conteúdo",
          "all": "Todo conteúdo",
          "static": "Conteúdo estático",
          "dynamic": "Conteúdo dinâmico"
        },
        "website_topic": {
          "title": "Tópico do site",
          "placeholder": "Restaurante de sushi...",
          "description": "Defina o tópico do site para melhor qualidade de tradução (ex. Jurídico, restaurante de sushi, loja virtual de peças de bicicleta…)\nInsira o tópico do site em inglês."
        },
        "apply_to_urls": {
          "title": "Aplicar a URLs",
          "description": "Selecione URLs específicos onde deseja aplicar a tradução por IA",
          "all_urls": "Todas as URLs",
          "selected_urls": "URLs selecionados",
          "label": "URL para aplicar",
          "placeholder": "URL para aplicar",
          "wildcard": "Curinga",
          "regex": "Expressão regular",
          "add": "Adicionar novo",
          "expression": "Tipo de expressão"
        },
        "apply_languages": {
          "title": "Aplicar a idiomas",
          "description": "Selecione idiomas específicos onde deseja aplicar a tradução por IA",
          "all_languages": "Todos os idiomas",
          "selected_languages": "Idiomas selecionados",
          "placeholder": "Selecionar idiomas…",
          "feedback": "Você deve escolher um idioma"
        },
        "formality": {
          "title": "Formalidade",
          "description": "Especifique o grau de formalidade nas traduções, possivelmente importante para públicos e contextos.\n\"Neutro\" tentará preservar a formalidade do conteúdo original.\n\"Formal\" é para conteúdo profissional, empresarial ou jurídico (ex. usando pronomes formais como \"usted\" em espanhol).\n\"Informal\" é para conteúdo casual e de conversa (ex. usando \"tú\" em espanhol).",
          "neutral": "Neutro",
          "formal": "Formal",
          "informal": "Informal"
        },
        "sentence_structure": {
          "title": "Estrutura das frases",
          "description": "Defina a preferência de estilo de escrita.",
          "classic": "Clássico",
          "short": "Frases curtas e impactantes",
          "detailed": "Frases detalhadas e explicativas"
        },
        "content_purpose": {
          "title": "Finalidade do conteúdo",
          "description": "Defina a finalidade funcional do conteúdo sendo traduzido.",
          "marketing": "Marketing/promocional (tom persuasivo e envolvente)",
          "technical": "Técnico/instrucional (claro, preciso e orientado à ação)",
          "support": "Suporte ao cliente (empático, útil e tranquilizador)",
          "legal": "Jurídico/conformidade (preciso, formal e inequívoco)",
          "educational": "Educacional (claro, estruturado e acessível)",
          "other": "Outro (em inglês)",
          "other_placeholder": "Descreva a finalidade…"
        },
        "target_audience": {
          "title": "Público-alvo",
          "description": "Especificação do público pretendido do conteúdo traduzido (em inglês).",
          "placeholder": "Por exemplo, pais que falam espanhol, responsáveis ​​pela privacidade na UE."
        },
        "override_default_translations": {
          "title": "Substituir tradução padrão",
          "description": "Se definido como SIM, esta opção forçará o conteúdo a ser traduzido com IA (Linguise AI), mesmo já tendo sido traduzido pela tradução via nuvem (modelo padrão)."
        },
        "force_replace_before": {
          "title": "Forçar a retradução por IA",
          "description": "Traduza novamente com IA todo o conteúdo cuja tradução por IA tenha sido criada antes da data selecionada — por exemplo, conteúdo traduzido com um modelo antigo. A retradução ocorrerá na próxima visita às páginas aplicáveis, de acordo com as regras, e usará os seus créditos de IA.",
          "before_date": "Antes de uma data"
        },
        "model": {
          "current": "Atual",
          "title": "Modelo",
          "description": "Selecione o modelo de tradução LLM que deseja usar",
          "load_error": "Não é possível carregar os modelos disponíveis. Por favor, tente novamente mais tarde.",
          "thinking_warning": "Este modelo usa um alto nível de raciocínio (\"pensamento\") e consumirá significativamente mais tokens por tradução."
        },
        "override_manual_and_selected": {
          "no_default": "Não (padrão)",
          "title": "Substituir traduções manuais e selecionadas",
          "description": "Por padrão, uma tradução que você editou manualmente permanece sempre no seu site, mesmo depois de ser gerada uma tradução aprimorada por IA. Defina como SIM para exibir a tradução aprimorada por IA. Suas traduções manuais são mantidas e você pode voltar atrás a qualquer momento. Isso também se aplica quando você traduz novamente as páginas para obter novas traduções; a tradução mais recente será usada automaticamente."
        }
      },
      "message": {
        "save_success": "Do conteúdo já traduzido, cerca de {{ai_affected_urls}} páginas serão aprimoradas com tradução por IA.",
        "save_success_only": "Configurações salvas com sucesso."
      }
    },
    "pricing": {
      "plan": {
        "title": "Comprar cota de tradução por IA",
        "buy_button": "COMPRAR PACOTE DE TRADUÇÃO POR IA"
      },
      "modal": {
        "title": "Confirmar mudança de plano",
        "description": "Tem certeza de que deseja alterar seu plano de Tradução por IA?",
        "button_cancel": "Cancelar",
        "button_confirm": "Confirmar",
        "loading": "Aguarde...",
        "amount": "Quantidade",
        "credit": "Crédito",
        "total_due": "Total a pagar"
      },
      "comparison": {
        "title": "Tradução por IA do Google Cloud\nvs Tradução por IA da Linguise",
        "list": {
          "0": {
            "google": "Traduções rápidas e fiáveis",
            "linguise": "Lida com expressões idiomáticas e técnicas"
          },
          "1": {
            "google": "Traduções instantâneas de todas as páginas do site",
            "linguise": "Geração das traduções em segundo plano"
          },
          "2": {
            "google": "Melhor qualidade, preço baixo",
            "linguise": "Qualidade perfeita, preço acessível"
          },
          "3": {
            "google": "Ideal para sites grandes ou orçamento reduzido",
            "linguise": "Melhor para sites que exigem qualidade de tradução perfeita"
          },
          "4": {
            "google": "Contexto da página para tradução",
            "linguise": "Contexto da página e do site para tradução"
          }
        }
      },
      "botom_banner": {
        "title": "Experimente a Precisão de Tradução Incomparável com a",
        "sub_title": "Nova Tradução por IA da Linguise",
        "description": "A Linguise está a melhorar os seus serviços de tradução automática com a introdução da Tradução por IA da Linguise, uma nova opção poderosa que utiliza a mais recente IA de tradução LLM (modelos Llama mais recentes otimizados para traduções). Esta adição oferece aos desenvolvedores de sites e agências web uma camada ainda mais elevada de qualidade de tradução, ideal para projetos onde a perfeição é primordial. A Tradução por IA da Linguise complementa a nossa tradução existente de alta qualidade por IA do Google Cloud, oferecendo-lhe maior flexibilidade e precisão."
      }
    },
    "success": {
      "tab_title": "Obrigado por adquirir o plano de Tradução por IA!",
      "title": "Obrigado por adquirir o plano de Tradução por IA!",
      "subtitle": "O seu plano de Tradução por IA foi adquirido com sucesso!",
      "message": "Pode gerir o seu plano de Tradução por IA na página de configurações da Tradução por IA.",
      "home": "Gerir Tradução por IA"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Nome",
        "description": "Nome da conta de faturação"
      },
      "phone": {
        "title": "Telefone",
        "description": "Telefone da conta de faturação"
      },
      "email": {
        "title": "Email",
        "description": "Email da conta de faturação"
      },
      "address": {
        "title": "Morada",
        "description": "Morada da conta de faturação",
        "city": "Cidade",
        "country": "País",
        "address1": "Endereço 1",
        "address2": "Endereço 2",
        "postal": "Código postal",
        "state": "Estado"
      },
      "tax": {
        "title": "Número fiscal"
      }
    }
  },
  "checkouts": {
    "header": "Finalizar compra",
    "payment_method": "Selecionar Método de Pagamento",
    "stripe_card": "Cartão de crédito (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Inserir nova morada de faturação",
      "existing": "Usar morada existente"
    },
    "pay_stripe": "Confirmar e pagar",
    "terms": "Ao confirmar a sua assinatura, permite que a Linguise lhe cobre pagamentos futuros de acordo com os nossos termos. Pode cancelar a sua assinatura a qualquer momento.",
    "coupon": {
      "title": "Tem um cupão?",
      "placeholder": "Insira aqui o seu código de cupão",
      "apply": "Aplicar",
      "percent": "{{0}}% de desconto"
    },
    "add_new": "Adicionar novo",
    "use_existing": "Usar método de pagamento existente",
    "recurring": {
      "month_single": "Faturado mensalmente",
      "month_many": "Faturado a cada {{count}} meses",
      "year_single": "Faturado anualmente",
      "year_many": "Faturado a cada {{count}} anos",
      "day_single": "Faturado diariamente",
      "day_many": "Faturado a cada {{count}} dias",
      "week_single": "Faturado semanalmente",
      "week_many": "Faturado a cada {{count}} semanas"
    },
    "add_new_no_stripe": "Adicionar novo cartão",
    "summary": {
      "title": "Resumo",
      "subtotal": "Subtotal",
      "total": "Total"
    }
  },
  "dashboard": {
    "main": {
      "title": "Painel"
    },
    "statistics": {
      "main_title": "Estatísticas dos últimos 30 dias",
      "characters": "Carateres traduzidos",
      "words": "Palavras traduzidas",
      "bandwidth": "Largura de banda de entrada",
      "request": "Pedidos",
      "page_views": "Visualizações de páginas por idioma (últimos 30 dias)",
      "multilingual_views": "Visualizações de páginas multilíngues (últimos 30 dias)",
      "most_page_viewed": "20 páginas mais visualizadas (últimos 30 dias)",
      "no_data_yet": "Ainda não há dados disponíveis",
      "th_language": "Idioma",
      "th_page_views": "Visualizações de páginas",
      "real_visitors": "Visitantes reais",
      "crawler": "Rastreador web"
    },
    "planHints": {
      "subscribeButton": "Subscrever",
      "upgradeButton": "Atualizar",
      "usedWords": "Está atualmente a usar {words_used} palavras",
      "noPlan": "Nenhum plano ativado para este domínio. Subscreva um plano e comece a traduzir o seu site",
      "noPlanShopify": "Nenhum plano ativado para este domínio. Subscreva um plano no seu painel Shopify e comece a traduzir o seu site",
      "trialUsage": "Está atualmente a usar {words_used} palavras das {words_allowed} palavras incluídas no plano de teste.",
      "trialEnds": "O teste de 1.º mês está ativado até {trial_ends}.",
      "subscribeMessage": "Subscreva antes de terminar para manter o seu site traduzido",
      "subscribeMessageShopify": "Subscreva a partir do seu painel Shopify antes de terminar para manter o seu site traduzido",
      "trialReachedLimit": "Atingiu o número máximo de palavras traduzidas para o período de teste.\nSubscreva um dos nossos planos para continuar a traduzir o seu site.",
      "paidUsage": "Usou {words_used} / {words_allowed} palavras traduzidas no seu plano.",
      "paidReachedLimit": "Atingiu o número máximo de palavras traduzidas para o plano atual.\nAtualize o seu plano para continuar a traduzir o conteúdo do seu site.",
      "trialOfferedUsage": "Está atualmente a usar {words_used} palavras das {words_allowed} palavras incluídas no plano de teste.(Incluindo as {free_words} palavras oferecidas)",
      "paidOfferedUsage": "Usou {words_used} / {words_allowed} palavras traduzidas no seu plano.(Incluindo as {free_words} palavras oferecidas)",
      "noPlanExtra": "Note que domínios inativos e os respetivos dados são automaticamente eliminados regularmente.",
      "planRecommended": "Com base no seu volume de tradução atual, o plano recomendado é:",
      "planMaximumWords": "{{words}} palavras",
      "notHaveTranslatedWords": "Ainda não fez nenhuma tradução"
    },
    "translationSetup": {
      "kicker": "CONFIGURAÇÃO DO SUBDOMÍNIO",
      "title": "Verificar a configuração da tradução",
      "description": "Revise o DNS, os hosts traduzidos, o acesso ao site original e os limites da conta.",
      "starting": "Verificando...",
      "button": "Verificar configuração",
      "viewLatest": "Ver último resultado",
      "viewCurrent": "Verificação atual",
      "runAgain": "Executar verificação novamente",
      "viewDetails": "Ver detalhes",
      "hideDetails": "Ocultar detalhes",
      "error": "Não foi possível verificar a configuração",
      "allPassed": "Todas as verificações foram aprovadas",
      "setupNeedsAttention": "A configuração precisa de atenção",
      "setupNeedsAttentionDescription": "Uma ou mais verificações falharam. Revise os itens abaixo ou entre em contato com o suporte da Linguise.",
      "lastChecked": "Última verificação: {{time}}",
      "domainOwnership": "Propriedade do domínio",
      "domainOwnershipDescription": "Registro de verificação encontrado",
      "domainOwnershipFailure": "Não foi possível verificar o registro DNS de propriedade.",
      "translatedHosts": "Hosts traduzidos",
      "translatedHostsDescription": "{{count}} hosts de idioma verificados",
      "translatedHostsFailure": "Um ou mais registros CNAME de idioma estão incorretos.",
      "subdomainPage": "Página do subdomínio",
      "subdomainPageDescription": "{{count}} páginas traduzidas aceitam HTTPS",
      "subdomainPageFailure": "A conexão TLS falhou ao abrir uma ou mais páginas traduzidas.",
      "originalSite": "Site original",
      "originalSiteDescription": "Verificações de DNS, TLS e resposta do site original",
      "originalSiteFailure": "A verificação de DNS, TLS ou resposta do site original falhou.",
      "documentationAdvice": {
        "dns": "Revisar configuração DNS",
        "tls": "Revisar configuração HTTPS",
        "origin": "Revisar configuração do site original",
        "diagnostic": "Revisar as etapas de solução de problemas"
      },
      "evidence": {
        "originDns": "DNS original",
        "originTls": "TLS original",
        "originHttp": "Resposta original",
        "observedTargets": "Destinos observados",
        "recordCount": "Registros encontrados",
        "addressCount": "Endereços encontrados",
        "statusCode": "Status HTTP",
        "redirect": "Redirecionamento",
        "expiresAt": "Validade do certificado expira",
        "raw": "{{key}}",
        "noValue": "Sem valor"
      },
      "checkerError": "Não foi possível concluir algumas verificações.",
      "coreLocation": "Verificado de {{location}}",
      "status": {
        "queued": "Na fila",
        "running": "Em execução",
        "completed": "Concluído",
        "failed": "Falhou",
        "passed": "Aprovado",
        "warning": "Aviso",
        "unknown": "Desconhecido",
        "skipped": "Ignorado",
        "not_applicable": "Não aplicável"
      }
    },
    "throttling": {
      "title": "Limite de tradução",
      "description": "Limites temporários de uso",
      "unavailable": "Limites temporários de tradução indisponíveis",
      "window": "{{used}} / {{max}} palavras",
      "resetsIn": "Redefine em {{time}}",
      "throttled": "Tradução pausada temporariamente",
      "throttledDescription": "Um limite temporário de uso foi atingido. A tradução será retomada quando este período for redefinido."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "PASSO {{step}} DE {{total}}",
      "doneLabel": "CONCLUÍDO, PODE COMEÇAR A TRADUZIR!",
      "finish": {
        "title": "",
        "description": "Esta é a chave API para usar no seu site"
      },
      "instructions": "Instruções de instalação",
      "domainSetting": "Definições do domínio",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "Script PHP",
        "wizardWordpressStep1": "1. Instale o ",
        "wizardWordpressStep2": "\n 2. Nas definições do plugin, copie e preencha a sua chave API\n",
        "wizardWordpressStep3": "3. Está pronto para traduzir\n\n",
        "wizardWordpressStep4": "Para instruções mais detalhadas, consulte nossa documentação: ",
        "wizardJoomlaStep1": "1. Link do pacote Joomla: ",
        "wizardJoomlaStep2": "\n2. Nas configurações da extensão, copie e preencha sua chave de API",
        "wizardJoomlaStep3": "3. Na configuração do módulo, defina os idiomas que deseja exibir e insira seu módulo onde necessário.",
        "wizardJoomlaStep4": "\n 4. Você está pronto para traduzir\n\n",
        "wizardPhpStep1": "1. Baixe nosso script php aqui ",
        "wizardPhpStep2": "\n2. Siga as instruções de instalação em nossa página de documentação aqui ",
        "wizardPhpStep3": "\n3. Adicione o módulo às suas páginas.",
        "wizardPhpStep4": "\n Copie o seguinte código e adicione ao cabeçalho da sua página html; ele exibirá automaticamente o módulo switcher\n",
        "dispatchStep1": "Enviamos com sucesso os dados necessários ao plugin Linguise; você já pode fechar esta janela.",
        "dispatchStep2": "Caso o token esteja faltando ao fechar esta janela, copie o seguinte token:",
        "dispatchStep3": "Você também pode copiar este snippet para ativar automaticamente nosso switcher de bandeiras",
        "wizardOtherStep1": "Siga as instruções abaixo para instalar o Linguise em seu domínio.\n",
        "wizardOtherStep2": "Copie o seguinte código e adicione ao cabeçalho da sua página html; ele exibirá automaticamente o módulo switcher.\n"
      },
      "trialAlreadyUsed": "Parece que você já usou seu teste gratuito, então precisa adquirir cota de tradução\nAssine um plano ou entre em contato conosco se precisar estender seu teste.",
      "usefulLinks": "Links úteis para começar",
      "linkDocumentation": "Documentação",
      "linkExtensionDl": "Download da extensão",
      "linkSubscribe": "Assine um plano agora",
      "linkDashboard": "Ir para o painel",
      "exclusion": {
        "title": "Nomes de empresas e produtos",
        "description": ""
      },
      "finishButton": "Concluir a configuração",
      "subdomains": "Subdomínios",
      "subdomain_setup": "Configurar domínio",
      "subdomain_auto_setup": "Conectar seu DNS automaticamente",
      "subdomain_manual_setup": "Adicionar entradas DNS eu mesmo",
      "subdomain_skip": "Fazer depois",
      "auto_subdomains_info": "Seu CMS requer configuração de DNS para definir idiomas por subdomínio (ex. es.dominio.com).",
      "auto_subdomains_info_2": "Você pode fazer isso automaticamente usando o Entri. Basta clicar no botão \"Conectar seu DNS automaticamente\" para começar a se conectar ao seu gerenciador de DNS e adicioná-los com o Entri.",
      "auto_subdomains_info_manual": "Ou pode configurar manualmente seu domínio clicando no botão \"Adicionar entradas DNS eu mesmo\".",
      "breadcrumbs": {
        "step1": "Etapa 1: Domínio, CMS e idiomas",
        "step2": "Etapa 2: DNS de idioma",
        "step3": "Passo {{step}}: Instruções de instalação"
      }
    },
    "form": {
      "urls": {
        "dash": "Traço -",
        "underscore": "Sublinhado _",
        "title": "Traduzir URLs",
        "description": "Deseja traduzir em todas as páginas",
        "char_description": "Caractere a ser usado para substituir caracteres não autorizados em URLs",
        "advertisement_title": "⚠ Você definiu muitos idiomas.\n",
        "advertisement": "Normalmente aconselhamos começar a traduzir sites com poucos idiomas. Você terá uma ideia de quantas palavras seu site possui. Também é melhor para SEO, pois os bots do Google rastrearão mais rapidamente todas as suas páginas se houver menos páginas inicialmente. Após uma semana você pode adicionar mais alguns idiomas e assim por diante."
      },
      "url": {
        "title": "Url",
        "description": "Coloque o URL do seu domínio principal começando com http:// ou https://",
        "placeholder": "URL do domínio",
        "advertisement_http": {
          "title": "Você não está usando o protocolo https",
          "description": "Por favor, verifique se seu domínio realmente não está usando o protocolo https, que hoje em dia é recomendado."
        },
        "advertisement_www": {
          "title": "Seu subdomínio não é www",
          "description": "Na maioria das vezes o subdomínio padrão é www (como https://www.mydomain.com). Talvez este não seja o seu caso, mas verifique novamente se o domínio que deseja adicionar está correto."
        },
        "invalid_url": {
          "line1": "Não conseguimos encontrar seu domínio. Verifique se ele está publicamente acessível pela Internet e não está redirecionado para outro local.",
          "line2": "Se tiver certeza de que seu domínio está acessível, pode pular a verificação de domínio e pressionar o botão \"Próxima etapa\" novamente",
          "contact": "Em qualquer caso, você pode entrar em contato conosco em",
          "force": "Pular verificação de domínio"
        },
        "invalid_subdomain_url": "Este URL não é permitido. Subdomínios devem estar no formato: https://www.dominio.tld ou https://dominio.tld sem subdiretório."
      },
      "account": {
        "title": "Conta",
        "description": "Selecione uma conta para atribuir este domínio",
        "placeholder": "Selecionar conta...",
        "feedback": "Você deve escolher uma conta"
      },
      "platform": {
        "title": "Plataforma",
        "description": "Selecione a plataforma do seu site pelo nome do CMS.",
        "learn": "Saiba como escolher",
        "placeholder": "Buscar plataforma pelo nome do CMS...",
        "info": {
          "title": "⚠ Esta plataforma foi adicionada recentemente.\n",
          "desc": "Esta plataforma de construção de sites é suportada pelo Linguise, embora tenha sido adicionada recentemente. Se encontrar algum problema, entre em contato conosco pelo e-mail de suporte direto:"
        },
        "description_read_only": "A plataforma que seu site está usando",
        "feedback": "Você deve escolher uma plataforma"
      },
      "language": {
        "title": "Idioma",
        "description": "Selecione o idioma base do seu site",
        "placeholder": "Selecionar idioma...",
        "feedback": "Você deve escolher um idioma",
        "description_read_only": "Idioma base do seu site"
      },
      "token": {
        "title": "Chave de API",
        "description": "Esta é a chave de API a copiar para seu site",
        "copy": "Copiar para a área de transferência",
        "reset": "Redefinir chave de API",
        "reset_confirm": "Confirme a redefinição da chave de API"
      },
      "languages": {
        "title": "Idiomas de tradução",
        "description": "Selecione os idiomas para os quais deseja que seu site seja traduzível",
        "placeholder": "Selecionar idiomas...",
        "feedback": "Você deve escolher um idioma"
      },
      "defaultRules": {
        "title": "Regras padrão",
        "description": "Definimos um conjunto de regras obrigatórias para melhorar a tradução e evitar que conteúdo indesejado seja traduzido, como o painel do WordPress.\nVocê pode remover ou editar essas regras depois, se desejar."
      },
      "disallow_deletion": "Não é possível excluir domínio com assinatura ativa",
      "delete_confirm": "Confirme a exclusão do domínio",
      "delete": "Excluir domínio",
      "dynamic": {
        "title": "Traduzir conteúdo dinâmico",
        "description": "Conteúdo dinâmico gerado por JavaScript e requisições AJAX será traduzido (esta opção aumentará seu uso de tradução)"
      },
      "partial_translations": {
        "title": "Permitir tradução parcial",
        "description": "Se sua conta atingiu sua cota de tradução, mas a página ainda requer tradução, o Linguise pode continuar exibindo a página com o conteúdo já traduzido.\nNo entanto, algumas partes da página permanecerão não traduzidas até que você aumente sua cota.\n\nEmbora uma pequena quantidade de conteúdo não traduzido geralmente não prejudique o SEO, permitir muito conteúdo não traduzido pode impactar negativamente a experiência do usuário.\nPara resolver isso, você pode definir um limite para a porcentagem de conteúdo não traduzido permitido em uma página. Se o conteúdo não traduzido exceder esse limite, os usuários serão automaticamente redirecionados para a versão original da página.",
        "never": "Nunca"
      },
      "translate_error_pages": {
        "title": "Traduzir páginas de erro",
        "description": "O Linguise pode traduzir todas as páginas de erro; no entanto, se sua página de erro contiver conteúdo dinâmico, como endereço IP ou ID de requisição, evite traduzi-las.",
        "not_found_page": {
          "title": "Traduzir página 404"
        },
        "error_page": {
          "title": "Traduzir outras páginas de erro"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Domínio existente encontrado",
          "description": "Um domínio existente foi encontrado para este usuário; deseja usá-lo?"
        }
      },
      "search_tl": {
        "title": "Buscar traduções",
        "description": "Ativar busca de traduções para a plataforma do seu site (Experimental, esta opção aumentará seu uso de tradução)"
      },
      "shopify_promo": {
        "info": "Boas notícias! Agora temos um aplicativo nativo da Shopify que você pode instalar na Shopify App Store.",
        "hyperlink": "Clique aqui e faça a instalação do Linguise pelo aplicativo.",
        "next_btn": "Acesse a loja Shopify para instalar o aplicativo.",
        "info_legacy": "Boas notícias! Agora temos um aplicativo nativo da Shopify que você pode instalar na Shopify App Store.",
        "description_legacy": "Selecione a plataforma \"Shopify\" em vez de \"Shopify Legacy\"."
      },
      "wix_promo": {
        "info": "Boas notícias! Agora temos um aplicativo nativo da Wix que você pode instalar na Wix App Market.",
        "hyperlink": "Clique aqui e faça a instalação do Linguise pelo aplicativo.",
        "next_btn": "Acesse a Wix App Market para instalar o aplicativo.",
        "info_legacy": "Boas notícias! Agora temos um aplicativo nativo da Wix que você pode instalar na Wix App Market.",
        "description_legacy": "Selecione a plataforma \"Wix\" em vez de \"Wix Legacy\"."
      },
      "ai_disallow_deletion": "Você não pode excluir este domínio enquanto uma cota de IA ainda estiver disponível.\n\nEntre em contato com nossa equipe de suporte se desejar excluir este domínio em",
      "language_removal": {
        "card": {
          "title": "Eliminar traduções dos idiomas removidos",
          "description": "Estes idiomas foram removidos do seu site, mas as traduções guardadas continuam a contar para a sua quota. Elimine-as para recuperar as palavras.",
          "button": "Eliminar traduções"
        },
        "hint": "As palavras utilizadas serão devolvidas à sua quota. Pode fazer isto uma vez a cada {{days}} dias por site.",
        "modal": {
          "title": "Eliminar traduções?",
          "intro": "Estas traduções serão eliminadas permanentemente:",
          "warning": "Esta ação não pode ser anulada. As palavras utilizadas serão devolvidas à sua quota, o que pode demorar alguns minutos.",
          "limit": "Pode fazer isto uma vez a cada {{days}} dias por site.",
          "confirm": "Eliminar traduções"
        },
        "scheduled": "As traduções estão a ser eliminadas e a sua quota será atualizada em breve.",
        "cooldown": "As traduções deste site foram eliminadas recentemente. Poderá eliminá-las novamente em {{date}}.",
        "latest_completed": {
          "title": "Última eliminação concluída",
          "description": "Consulte os idiomas eliminados e as palavras devolvidas à sua quota.",
          "languages": "Idiomas eliminados",
          "words_returned": "Palavras devolvidas à sua quota: {{words}}",
          "completed_at": "Concluído em {{date}}"
        },
        "status": {
          "recent_title": "Eliminação recente de traduções",
          "recent_description": "Acompanhe a última eliminação e veja quando poderá iniciar outra.",
          "progress_title": "Progresso da eliminação",
          "loading": "A verificar o progresso da eliminação...",
          "unavailable": "Não foi possível carregar o progresso da eliminação. Atualize a página e tente novamente.",
          "label": "Estado",
          "pending": "Na fila",
          "processing": "Em curso",
          "completed": "Concluído",
          "failed": "Falhou",
          "unknown": "Estado indisponível",
          "percent": "{{percent}}% concluído",
          "current_stage": "Etapa atual: {{stage}}",
          "processed": "{{processed}} registos processados",
          "processed_total": "{{processed}} de {{total}} registos processados",
          "requested_at": "Pedido em {{date}}",
          "started_at": "Iniciado em {{date}}",
          "completed_at": "Concluído em {{date}}",
          "cooldown_period": "Pode fazer isto uma vez a cada {{days}} dias por site.",
          "cooldown_blocked": "Ainda não é possível iniciar outra eliminação.",
          "stage": {
            "queued": "A aguardar início",
            "processing": "Em curso",
            "refund_summary": "A calcular palavras devolvidas",
            "search_translations": "A eliminar traduções de pesquisa",
            "url_translations": "A eliminar traduções de URL",
            "translations": "A eliminar traduções",
            "completed": "Concluído",
            "failed": "Falhou",
            "unknown": "Em curso"
          }
        },
        "forbidden": "Não tem permissão para eliminar traduções."
      }
    },
    "main": {
      "edit": "Editar domínio",
      "add": "Adicionar domínio",
      "wizard": "Assistente de criação de novo domínio",
      "common": "Domínio"
    },
    "notice": {
      "broken_card": "Não conseguimos renovar seu plano para {{url}} usando o método de pagamento atual; atualize seu cartão de pagamento",
      "quota_reached": "Sua cota de tradução para {{url}} foi atingida; faça upgrade para retomar a tradução do seu site",
      "ai_no_subscription": "Tradução AI para {{url}} requer assinatura ativa ou teste ativo. Ela será interrompida sem isso; faça upgrade para continuar",
      "important": "Importante",
      "quota_reached_button": "Atualize seu plano agora",
      "broken_card_button": "Atualize seu cartão de pagamento",
      "ai_no_subscription_button": "Atualize seu plano agora",
      "quota_warning": "Sua cota de tradução para {{url}} atingiu {{throttling_used_percent}}%, ela será reiniciada em {{ttl}}",
      "locked": "O domínio {{url}} está atualmente bloqueado para migração. Você ainda pode acessar seu site, mas não pode editar ou adicionar novas traduções!"
    },
    "subdomains": {
      "config_ok": "A configuração do DNS dos subdomínios foi feita corretamente.",
      "config_invalid": "O DNS dos subdomínios precisa de configuração adicional para funcionar.",
      "config_check": "A verificação da configuração do DNS dos subdomínios está em curso, aguarde...",
      "entri_timeout": "O Entri informou que o tempo de propagação do DNS dos seus subdomínios expirou; você precisa tentar novamente ou fazê-lo manualmente.",
      "entri_process": "Seu DNS foi adicionado com o Entri e normalmente leva 10-30 minutos para propagar (aplicar todos os subdomínios de idiomas como es.domain.com). Se a validação do DNS não for concluída após 24 horas, entre em contato com nossa equipe de suporte: support@linguise.com",
      "entri_ok": "A propagação do DNS está em andamento! Aguardando propagação...",
      "infos": "Você precisa adicionar essas entradas DNS aos seus registros de domínio DNS para ativar a tradução. Clique no botão de verificação quando terminar. É possível que a propagação dos registros DNS leve algum tempo, então talvez seja necessário retornar após alguns minutos ou horas.",
      "check": "Verifique a configuração de DNS"
    },
    "subscription": {
      "next_payment_amount": "Próximas cobranças",
      "next_payment_date": "Próxima data de pagamento",
      "invoice": {
        "header": "Histórico de faturas",
        "date": "Data",
        "amount_due": "Valor",
        "status": "Status",
        "actions": "Ações",
        "description": "Assim que as transações estiverem disponíveis, você poderá visualizá-las aqui.",
        "status_text": {
          "draft": "Rascunho",
          "failed": "Falhou",
          "open": "Pendente",
          "paid": "Pago",
          "retrying": "Tentando novamente",
          "uncollectible": "Inadimplente",
          "void": "Anulada"
        },
        "view": "Ver",
        "empty": "Nenhuma fatura recente encontrada para esta assinatura",
        "retry_payment": "Tentar novamente"
      },
      "next_cancellation": "Data de cancelamento",
      "cancel": "Cancelar assinatura",
      "change_plan": "Mudar de plano",
      "change": "Alterar",
      "suspend": "Suspender pagamento",
      "resume": "Retomar assinatura",
      "back": "Voltar",
      "save": "Salvar",
      "confirm_resume": "Tem certeza de que deseja retomar esta assinatura?",
      "confirm_cancel": "Tem certeza de que deseja cancelar esta assinatura?",
      "confirm_header": "Tem certeza?",
      "missing_status": "Esta assinatura está faltando",
      "not_found": "Nenhuma assinatura encontrada para este domínio",
      "confirm_manual_retry": "Tem certeza de que deseja tentar este pagamento novamente?",
      "no_payment_method": "Desconhecido",
      "remove_billing": "Remover",
      "shopify_maneged": "Esta assinatura é gerenciada pelo Shopify. Gerencie-a no painel administrativo do seu Shopify.",
      "unknown_plan": "Plano desconhecido"
    }
  },
  "domain_listing": {
    "add": "Adicionar site",
    "select": "Escolha um domínio"
  },
  "editable": {
    "number": "número {{id}}"
  },
  "footer": {
    "about": "Sobre",
    "support": "Suporte"
  },
  "frontendEditor": {
    "main": "Editor ao Vivo",
    "description": "O Editor ao Vivo ajuda você a editar diretamente as traduções no seu site.",
    "button": "Abrir Editor ao Vivo",
    "language_selection": "Seleção do idioma de tradução",
    "video_label": "Aprenda a usar o editor ao vivo"
  },
  "general": {
    "403": {
      "tab_title": "Ops - Erro 403",
      "title": "Acesso negado",
      "message": "Parece que você não tem acesso à página solicitada.",
      "home": "Voltar para o Início"
    },
    "404": {
      "tab_title": "Ops - Erro 404",
      "title": "Página Não Encontrada",
      "message": "Parece que você pode ter perdido o caminho. Não se preocupe... isso acontece com os melhores. Aqui está uma dica que pode ajudá-lo a voltar ao caminho.",
      "home": "Voltar para o Início"
    },
    "500": {
      "tab_title": "Erro 500",
      "title": "Erro Interno do Servidor",
      "message": "Que tal tentar atualizar a página? ou você pode nos contatar",
      "home": "Voltar para o Início"
    },
    "fields": {
      "alert": "Alguns campos não são válidos, corrija os campos inválidos.",
      "invalid": "Este campo é inválido",
      "phone_re": "Número de telefone inválido",
      "phone_invalid": "Número de telefone inválido",
      "email": "O campo de e-mail é inválido."
    },
    "table": {
      "no_data": "Ainda não há dados aqui..."
    },
    "saving": "Salvando ...",
    "save": "Salvar",
    "save_and_quit": "Salvar & Sair",
    "invite": "Convidar",
    "cancel": "Cancelar",
    "yes": "Sim",
    "no": "Não",
    "nextStep": "Próxima etapa",
    "loading": "Aguarde enquanto o aplicativo carrega",
    "goback": "Voltar",
    "manage": "Gerenciar",
    "delete": "Excluir",
    "deleting": "Excluindo ...",
    "confirm": "Confirmar",
    "unknown": "Desconhecido",
    "hide": "Esconder",
    "show": "Mostrar",
    "on": "Sobre",
    "off": "Desligado",
    "default": "Padrão"
  },
  "home": {
    "header": "Início",
    "manage": "Gerenciar assinatura",
    "canceled": "Agendado para cancelamento",
    "activate_now": "Ativar agora",
    "activate_plan_now": "Assinar agora",
    "upgrade_plan_now": "Atualizar plano agora",
    "trial_message_part_1": "Você está atualmente no plano de teste, ",
    "trial_message_part_2": "você pode ativar uma assinatura a qualquer momento.",
    "add": "Adicionar domínio",
    "table": {
      "title": "Domínios",
      "description": "Lista dos seus domínios, clique no domínio para gerenciar as traduções"
    },
    "domains": {
      "empty": "Você não possui nenhum domínio nesta conta"
    },
    "accountsList": {
      "title": "Contas",
      "add": "Adicionar nova conta",
      "name": "Nome da conta"
    },
    "update_credit_card": "Atualizar dados do cartão de crédito",
    "cancelling_subs": "Cancelando em {{0}}",
    "resume_subscription": "Retomar assinatura",
    "shopify_managed": "Gerenciado por Shopify",
    "trial_ends_at": "Termina às {{0}}",
    "free_trial": "Teste grátis",
    "no_subs": "Nenhuma assinatura ativa"
  },
  "invoices": {
    "title": "Faturas",
    "list": {
      "title": "Lista de faturas"
    },
    "table": {
      "customer": "Cliente",
      "domain": "Domínio",
      "amountPaid": "Valor Pago",
      "status": "Status",
      "date": "Data",
      "invoice": "Fatura",
      "pay": "Pagar fatura",
      "actions": "Ações",
      "deleted_domain": "Domínio excluído",
      "plan_name": "Plano",
      "action": "Ação"
    },
    "listPending": {
      "title": "Lista de faturas pendentes"
    }
  },
  "language_settings": {
    "display": "Exibição da lista de idiomas",
    "position": "Posição",
    "display_help_text": "Exibir bandeira e/ou nomes dos idiomas. A posição padrão do seletor de idioma pode ser em qualquer lugar do conteúdo ou em uma posição fixa que permanece fixa ou se move ao rolar",
    "side_by_side": "Lado a lado",
    "dropdown": "Menu suspenso",
    "popup": "Popup",
    "flag": "Bandeira",
    "lang_name": "Nome do idioma",
    "lang_short_name": "Nomes curtos",
    "positions": {
      "in_place": "No lugar",
      "top_left": "Superior esquerdo",
      "top_left_no_scroll": "Superior esquerdo (sem rolagem)",
      "top_right": "Superior direito",
      "top_right_no_scroll": "Superior direito (sem rolagem)",
      "bottom_left": "Inferior esquerdo",
      "bottom_left_no_scroll": "Inferior esquerdo (sem rolagem)",
      "bottom_right": "Inferior direito",
      "bottom_right_no_scroll": "Inferior direito (sem rolagem)"
    },
    "lang_names_display": {
      "title": "Exibição dos nomes dos idiomas",
      "help_text": "No seletor de idioma, exiba os nomes em inglês ou no idioma original, ex.: Francês ou Français",
      "english": "Inglês",
      "native_languages": "Idiomas nativos"
    },
    "flag_shape": {
      "title": "Estilo da bandeira",
      "help_text": "Usar ícones de bandeira svg redondos ou retangulares",
      "round": "Redondo",
      "rectangular": "Retangular"
    },
    "english_flag_type": {
      "title": "Tipo de bandeira do inglês",
      "help_text": "Usar a bandeira da Grã-Bretanha ou dos EUA para o inglês",
      "usa": "Bandeira dos EUA",
      "great_britain": "Bandeira da Grã-Bretanha"
    },
    "german_flag_type": {
      "title": "Tipo de bandeira do alemão",
      "help_text": "Usar a bandeira da Áustria ou da Alemanha para o alemão",
      "german": "Bandeira da Alemanha",
      "austria": "Bandeira da Áustria"
    },
    "spain_flag_type": {
      "title": "Tipo de bandeira do espanhol",
      "help_text": "Usar a bandeira do México ou da Espanha para o espanhol",
      "spanish": "Bandeira da Espanha",
      "mexico": "Bandeira do México",
      "peruvian": "Bandeira do Peru"
    },
    "portugal_flag_type": {
      "title": "Tipo de bandeira do português",
      "help_text": "Usar a bandeira de Portugal ou do Brasil para o português",
      "portugal": "Bandeira de Portugal",
      "brazil": "Bandeira do Brasil"
    },
    "taiwanese_flag_type": {
      "title": "Tipo de bandeira de Taiwan",
      "help_text": "Usar a bandeira de Taiwan ou da China para o chinês de Taiwan",
      "taiwanese": "Bandeira de Taiwan",
      "chinese": "Bandeira da China"
    },
    "flag_border_radius": {
      "title": "Raio da borda da bandeira (px)",
      "help_text": "Se estiver usando bandeira retangular, pode aplicar raio de borda personalizado em pixels"
    },
    "flag_width": {
      "title": "Tamanho da bandeira (px)",
      "help_text": "Selecione o tamanho das bandeiras em pixels. Isso não altera o peso da imagem, pois está em formato .svg"
    },
    "lang_color": {
      "color_title": "Cor do nome do idioma",
      "color_help_text": "Selecione uma cor de texto padrão para os nomes dos idiomas",
      "hover_color_title": "Cor de hover do nome do idioma",
      "hover_color_help_text": "Selecione uma cor de texto ao passar o mouse para os nomes dos idiomas",
      "color_popup_title": "Cor do idioma no popup",
      "color_popup_help_text": "Cor do título do idioma nas áreas popup ou dropdown",
      "hover_color_popup_title": "Cor de hover do título no popup",
      "hover_color_popup_help_text": "Selecione uma cor de texto ao passar o mouse no título do idioma nas áreas popup ou dropdown"
    },
    "flag_box_shadow": {
      "shadow_title": "Sombra da bandeira",
      "shadow_help_text": "Cor e tamanho da sombra para as bandeiras de idiomas",
      "hover_shadow_title": "Sombra da bandeira no hover",
      "hover_shadow_help_text": "Cor e tamanho da sombra ao passar o mouse sobre as bandeiras",
      "shadow_h_offset": "Deslocamento H da sombra (px)",
      "shadow_v_offset": "Deslocamento V da sombra (px)",
      "shadow_blur": "Desfoque da sombra (px)",
      "shadow_spread": "Expansão da sombra (px)",
      "shadow_color": "Cor da sombra"
    },
    "order": "Ordem dos idiomas",
    "language_order_help": "Ordem dos idiomas que será exibida no seletor. Você pode arrastar e soltar os idiomas para reordená-los",
    "order_reset": "Redefinir ordem",
    "language_order_dragdrop": "Você pode arrastar e soltar os idiomas para reordená-los",
    "popup_lang_name": "Nome do idioma no popup",
    "preview": "Pré-visualização do idioma"
  },
  "link": {
    "form": {
      "original": {
        "title": "Fonte original",
        "description": "Adicione seu link de URL original e substitua-o abaixo por idioma para traduzi-lo",
        "srcset_description": "Você está editando uma URL de imagem. Leia a documentação, especialmente se usar srcset ou não souber o que é",
        "link": "Ligação",
        "match_link": "Modo de correspondência",
        "match_exact": "Exata",
        "match_wildcard": "Curinga",
        "match_regex": "Expressão regular"
      },
      "alternative_languages": {
        "title": "Links para substituir",
        "description": "Substitua links de mídia e links externos em todas as suas páginas, por idioma…",
        "link": "Link para substituir"
      },
      "error": {
        "atLeastOne": "Por favor, adicione pelo menos uma tradução.",
        "url": "O url é inválido",
        "extension": "O link deve ter uma extensão, mas não pode ser .html ou .php. E o link não deve conter nenhum caminho de idioma, por exemplo \"/fr\"",
        "regex": "A regex é inválida",
        "wildcard": "O link curinga tem um protocolo inválido"
      }
    },
    "main": {
      "parent": "Ligações",
      "edit": "Editar link"
    }
  },
  "links": {
    "title": "Gestão de links de mídia e externos",
    "description": "Liste e edite os links de mídia ou externos do seu site.",
    "add": "Adicionar Link",
    "delete": "Eliminar Link",
    "table": {
      "original": "Original",
      "language": "Idioma",
      "translation": "Tradução",
      "action": "Ação",
      "delete_confirm": "Por favor confirme a eliminação do link"
    }
  },
  "members": {
    "header": "Membros",
    "invite": "Convidar novo membro",
    "modal": {
      "inviteHeader": "Convidar novo membro",
      "editHeader": "Editar membro",
      "detachHeader": "Desanexar membro",
      "detachBody": "Tem certeza de que deseja desanexar o membro desta conta?",
      "selfDetachBody": "Tem certeza de que deseja remover-se da gestão desta conta? Depois disso, não poderá aceder a nenhum dos dados relacionados com esta conta."
    },
    "table": {
      "title": "Lista de membros",
      "description": "Funções dos membros e acesso aos domínios",
      "name": "Nome",
      "email": "E-mail",
      "websites": "Sites",
      "languages": "Idiomas",
      "role": "Função",
      "status": "Estado",
      "resendInvite": "reenviar",
      "inviteSent": "convite foi enviado",
      "actions": "Ações",
      "edit": "Editar",
      "detach": "Desanexar",
      "empty": "Ainda não tem membros",
      "all_website": "Todos os sites e idiomas",
      "roles": {
        "admin": "Administrador",
        "manager": "Gerente",
        "translator": "Tradutor"
      },
      "statuses": {
        "pending": "Pendente",
        "accepted": "Aceito",
        "declined": "Recusado"
      }
    },
    "errors": {
      "role": "Deve escolher uma função",
      "domains": "Deve escolher pelo menos 1 site para a função selecionada",
      "languages": "Deve escolher pelo menos 1 idioma para os sites selecionados"
    },
    "inviteSent": "O seu convite foi enviado com sucesso"
  },
  "pagination": {
    "showing": "A mostrar {{limit}} de {{total}} resultados",
    "showing_only_count": "A mostrar {{limit}} resultados"
  },
  "payments_method": {
    "header": "Métodos de Pagamento",
    "table": {
      "title": "Lista de métodos de pagamento",
      "description": "Métodos de pagamento associados à sua conta",
      "default": "Predefinido",
      "action_edit_remove": "Editar ou remover",
      "action_remove": "Remover",
      "action_default": "Definir como predefinido",
      "action_fallback": "Definir como fallback",
      "expires": "Expira",
      "add_new_card": "Adicionar método de pagamento",
      "action_fallback_remove": "Remover do fallback",
      "fallback": "Alternativo",
      "action_edit": "Editar",
      "action_delete": "Eliminar",
      "action_default_remove": "Remover como Predefinido",
      "domain_count@@one": "Usado por {{count}} domínios",
      "domain_count@@other": "Usado por {{count}} domínios"
    },
    "paypal_bind": {
      "button": "Ligar Conta PayPal",
      "button_load": "A ligar...",
      "disconnected": "Não ligado",
      "success": "A sua conta PayPal está agora ligada; $5 serão deduzidos da sua próxima fatura!",
      "success_no_promo": "A sua conta PayPal está agora ligada",
      "error": "Ocorreu um erro",
      "success_header": "Sucesso"
    },
    "card_add": {
      "header": "Adicionar novo cartão",
      "success": "Novo cartão ligado ao Linguise!",
      "terms": "Ao fornecer os dados do seu cartão, permite que a Linguise cobre o seu cartão para pagamentos futuros de acordo com os nossos termos de serviço."
    },
    "card_detail": {
      "header": "Informações do cartão",
      "delete": {
        "error": "Não pode eliminar este método de pagamento porque tem subscrições ativas!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Subscrições neste método de pagamento",
        "header_domain": "Domínio",
        "header_plan": "Plano",
        "header_status": "Estado",
        "header_actions": "Ações",
        "cancelling": "A cancelar em: {{0}}",
        "next_payment": "Próximo pagamento em: {{0}}",
        "action_renew": "Renovar",
        "no_subs_header": "Nenhuma subscrição para mostrar",
        "no_subs_desc": "Assim que uma subscrição for feita neste cartão, toda a informação será exibida aqui",
        "action_manage": "Gerir"
      },
      "status": {
        "active": "Ativa",
        "canceled": "Cancelada",
        "incomplete": "Não paga",
        "incomplete_expired": "Não paga (Expirada)",
        "missing": "Erro",
        "past_due": "Em atraso",
        "trialing": "Avaliação",
        "unpaid": "Não paga"
      }
    },
    "delete_confirm_body": "Tem certeza de que deseja eliminar este método de pagamento? Esta ação não pode ser revertida!",
    "delete_confirm_header": "Eliminar método de pagamento?",
    "card_edit": {
      "header": "Editar cartão",
      "billing_header": "Informações de faturação",
      "address_error": "O endereço é obrigatório!",
      "card_number": "Número do cartão",
      "card_expiry": "Data de validade",
      "expiry_error_month": "Mês inválido",
      "expiry_error_year": "Ano inválido",
      "expiry_error_expired": "O ano de vencimento do seu cartão já passou.",
      "card_header": "Informações do cartão",
      "expiry_error_empty": "Este campo é obrigatório!"
    }
  },
  "plans": {
    "per": "por",
    "wordsTranslated": "palavras traduzidas",
    "current": "Atual",
    "archived": "Arquivado",
    "day": "dia",
    "week": "semana",
    "month": "mês",
    "year": "ano",
    "activate": "Ativar",
    "cancel": "Cancelar",
    "change": "Alterar",
    "upgrade": "Fazer upgrade",
    "downgrade": "Fazer downgrade",
    "resume": "Retomar",
    "notEnoughWords": "Palavras insuficientes",
    "yearIntervalOnly": "Não é possível migrar do plano anual",
    "subsCanceled": "Existe outro cancelamento de assinatura em andamento",
    "wordsUnlimited": "Palavras ilimitadas",
    "tabs": {
      "day": "Preços diários",
      "week": "Preços semanais",
      "month": "Preços mensais",
      "year": "Preços anuais",
      "sub_texts": {
        "day": "Preço fixo, todos os dias",
        "week": "Preço fixo, toda semana",
        "month": "Preço fixo, todo mês",
        "year": "Um mês grátis, uma fatura por ano"
      }
    },
    "details": {
      "new_languages": "Adicione novos idiomas a qualquer momento",
      "one_month_trial": "Teste grátis de um mês para cada novo site",
      "multi_content_indexed": "100% do conteúdo multilíngue indexado",
      "translate_new_content": "Traduza novo conteúdo instantaneamente",
      "free_installation": "Instalação e configuração gratuitas",
      "compared_monthly_plan": "Um mês grátis comparado aos planos mensais",
      "risk_free_recurring": "Falhas de pagamento recorrente sem riscos",
      "unlimited_languages": "Idiomas e visualizações de página ilimitados",
      "high_server_resources": "Altos recursos de servidor",
      "billed": {
        "day": "Cobrança diária",
        "week": "Cobrança semanal",
        "month": "Cobrança mensal",
        "year": "Cobrança anual"
      },
      "request_max_size": "{{0}} tamanho máx. da requisição"
    },
    "frequent_question": {
      "title": "Perguntas frequentes",
      "questions": {
        "trial": {
          "question": "Posso usar o teste em um novo domínio de site?",
          "answer": "Sim, oferecemos um teste grátis de 30 dias para cada novo domínio que você adicionar à sua conta. Assim, você pode testar completamente o serviço de tradução em seu novo site."
        },
        "seo": {
          "question": "Quanto tempo leva para meu SEO melhorar?",
          "answer": "Conteúdo, e conteúdo multilíngue, levam tempo para ser totalmente indexado e bem ranqueado. Dependendo do tráfego e tamanho do seu site, leva entre 3 e 6 semanas."
        },
        "quota": {
          "question": "As traduções humanas estão incluídas na cota?",
          "answer": "Não, o limite de palavras é apenas para traduções automáticas por máquina. Um tradutor pode editar manualmente traduções automáticas sem limite."
        }
      }
    },
    "best_offer": "Melhor oferta",
    "period": {
      "days@@one": "dia",
      "days@@other": "{{count}} dias",
      "hours@@one": "hora",
      "hours@@other": "{{count}} horas",
      "minutes@@one": "minuto",
      "minutes@@other": "{{count}} minutos",
      "seconds@@one": "segundo",
      "seconds@@other": "{{count}} segundos"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "{{words}} palavras por {{period}}"
  },
  "profile": {
    "welcome": "Bem-vindo!",
    "account": "Minha Conta",
    "subscriptions": "Assinaturas",
    "logout": "Sair"
  },
  "register": {
    "errors": {
      "password": "Mínimo 8 caracteres, qualquer caractere"
    }
  },
  "route": {
    "dashboard": "Painel",
    "rules": "Regras",
    "translations": "Traduções",
    "search_translations": "Termos de Busca",
    "urls_translations": "Traduções de URLs",
    "links": "Links de mídia e externos",
    "online_editor": "Editor ao Vivo",
    "settings": "Configurações",
    "domain": {
      "finish": "Configurações",
      "preconfig": "Configurações"
    },
    "home": "Início",
    "domain_list": "Lista de domínios",
    "members": "Membros",
    "invoices": "Faturas",
    "billing": "Detalhes de cobrança",
    "language_display": "Exibição das bandeiras de idioma",
    "payment_methods": "Métodos de Pagamento",
    "ai_translation": "Tradução por IA",
    "ai_translation_settings": "Configurações",
    "ai_translation_pricing": "Preços"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Texto para ignorar",
        "add": "Adicionar novo",
        "title": "Texto para ignorar",
        "description": "Adicione um ou vários textos para ignorar",
        "ignore_case": "Ignorar maiúsculas/minúsculas"
      },
      "html_content": {
        "title": "Aplicar ao conteúdo html",
        "description": "Aplique a regra em todo o conteúdo ou selecionando um seletor CSS específico",
        "all_page": "Toda a página",
        "css_selector": "Seletor CSS",
        "label": "Seletor CSS",
        "placeholder": "Seletor a aplicar",
        "add": "Adicionar novo"
      },
      "apply_to_urls": {
        "title": "Aplicar a URLs",
        "description": "Selecione URLs específicos onde deseja aplicar a regra",
        "all_urls": "Todas as URLs",
        "selected_urls": "URLs selecionadas",
        "label": "URL a aplicar",
        "placeholder": "URL a aplicar",
        "original_url": "URLs originais",
        "translated_url": "URL traduzida",
        "wildcard": "Caractere-curinga",
        "regex": "Expressão regular",
        "add": "Adicionar novo",
        "expression": "Tipo de expressão"
      },
      "apply_urls": {
        "title_exclude": "Excluir em URLs",
        "title_replace": "Substituir em URLs",
        "title_description": "Aplicar também esta regra à tradução de URLs"
      },
      "apply_languages": {
        "title": "Aplicar a idiomas",
        "description": "Selecione idiomas específicos onde deseja aplicar a regra",
        "all_languages": "Todos os idiomas",
        "selected_languages": "Idiomas selecionados",
        "placeholder": "Selecione idiomas...",
        "feedback": "Você deve escolher um idioma"
      },
      "name": {
        "title": "Título",
        "description": "Dê um título à sua regra para facilitar",
        "placeholder": "Nome da regra"
      },
      "type": {
        "title": "Tipo",
        "description": "Escolha o tipo de regra que deseja adicionar",
        "text_ignore": "Ignorar texto",
        "text_replace": "Substituir texto",
        "content_exclusion": "Exclusão de conteúdo",
        "url_exclusion": "Exclusão por URL",
        "ignore_inline": "Ignorar em linha",
        "full_description": {
          "text_ignore": "Adicione regras para evitar que determinado texto seja traduzido. Pode ser o nome do seu produto, marca ou outros elementos técnicos que você não quer traduzir.",
          "text_replace": "Substituir texto permite substituir um texto pela tradução desejada, podendo ser necessário quando a tradução ignora o contexto.",
          "content_exclusion": "A exclusão de conteúdo ajuda a evitar a tradução de parte do conteúdo da página.\nSe quiser excluir completamente uma página da tradução (sem URL multilíngue e sem conteúdo traduzido), use o tipo \"Exclusão por URL\".",
          "url_exclusion": "A exclusão de tradução de página ajuda a definir as páginas que você não quer traduzir.",
          "ignore_inline": "Evite traduzir conteúdo como conteúdo em linha; traduza cada tag separadamente."
        }
      },
      "text_replace": {
        "title": "Texto a substituir",
        "description": "Substitua um texto por sua tradução específica. Substitua qualquer texto em suas páginas, por idioma…",
        "text_to_replace": "Texto a substituir",
        "ignore_case": "Ignorar maiúsculas/minúsculas",
        "text_type": "Substituição na tradução",
        "text_type_original": "Original",
        "text_type_translation": "Tradução",
        "keep_case": "Tentar manter maiúsculas/minúsculas",
        "add": "Adicionar novo"
      },
      "content_exclusion": {
        "title": "Exclusão de conteúdo",
        "description": "Selecione um ou mais seletores CSS que não serão traduzidos",
        "label": "Seletor CSS",
        "placeholder": "Seletor a aplicar",
        "add": "Adicionar novo"
      },
      "multilingual_url": {
        "title": "Usar URL multilíngue",
        "description": "Se definido como Sim, o URL NÃO será traduzido, mas a página continuará multilíngue com conteúdo traduzido",
        "live_example_title": "Exemplo em tempo real",
        "live_example_description": "URL de origem: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "URL gerado: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "URL gerado: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Aplique a regra em conteúdo estático, dinâmico ou ambos",
        "title": "Aplicar ao conteúdo",
        "all": "Todo conteúdo",
        "static": "Conteúdo estático",
        "dynamic": "Conteúdo dinâmico"
      },
      "force_apply_urls": {
        "title_description": "Force a aplicação desta regra a todas as traduções de URLs, incluindo traduções existentes!",
        "title_replace": "Forçar substituição em URLs",
        "title_exclude": "Forçar exclusão em URLs",
        "warning": "Aviso",
        "warning_part1": "Definir isso como \"Sim\" pode quebrar as traduções de URLs do seu site.",
        "warning_part2": "Isso pode gerar temporariamente ou permanentemente uma página 404; continue apenas se compreender as consequências.",
        "warning_replacement_original": "Aviso adicional: Você está tentando substituir conteúdo original que pode afetar URL; a tradução pode falhar, pois a Linguise não conseguirá encontrar as URLs originais corretamente."
      }
    },
    "main": {
      "parent": "Regras",
      "edit": "Editar regra",
      "add": "Nova regra"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" será ignorado no conteúdo e na URL",
      "preview_single": "\"{{text_ignore}}\" será ignorado no conteúdo",
      "preview_more_with_url": "\"{{text_ignore}}\" e mais {{count}} serão ignorados no conteúdo",
      "preview_more": "\"{{text_ignore}}\" e mais {{count}} serão ignorados no conteúdo",
      "other_parameters": "Outros parâmetros estão definidos para esta regra; clique no botão editar para mais informações"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" é substituído por \"{{replacement}}\" no conteúdo e nas URLs",
      "preview_single": "\"{{original}}\" é substituído por \"{{replacement}}\" no conteúdo",
      "preview_more_with_url": "\"{{original}}\" é substituído por \"{{replacement}}\" no conteúdo e nas URLs, e mais {{nb}}",
      "preview_more": "\"{{original}}\" é substituído por \"{{replacement}}\" no conteúdo, e mais {{nb}}",
      "other_parameters": "Outros parâmetros estão definidos para esta regra; clique no botão editar para mais informações"
    },
    "content_exclusion": {
      "selectors": "{{nb}} seletor(es) CSS excluídos da tradução",
      "other_parameters": "Outros parâmetros estão definidos para esta regra; clique no botão editar para mais informações"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URLs estão excluídas da tradução, mas ainda mantêm o prefixo multilíngue",
      "some": "{{nb}} URLs estão completamente excluídas da tradução",
      "all_multilingual": "todas as URLs estão excluídas da tradução, mas ainda mantêm o prefixo multilíngue",
      "all": "todas as URLs estão completamente excluídas da tradução",
      "other_parameters": "Outros parâmetros estão definidos para esta regra; clique no botão editar para mais informações"
    },
    "ignore_inline": {
      "elements": "Todo conteúdo em linha será traduzido como conteúdo de bloco na página",
      "all_elements": "Parte do conteúdo em linha será traduzido como conteúdo de bloco na página",
      "other_parameters": "Outros parâmetros estão definidos para esta regra; clique no botão Editar para obter mais informações."
    },
    "title": "Gerenciamento de regras",
    "description": "Gerencie as exclusões e substituições de conteúdo de suas traduções por todo o site",
    "add": "Adicionar nova regra",
    "table": {
      "title": "Título",
      "no_data": "Ainda não há regras aqui",
      "type": "Tipo",
      "preview": "Pré-visualização da regra",
      "action": "Ação",
      "delete_confirm": "Por favor, confirme a exclusão da regra",
      "types": {
        "text_ignore": "Ignorar texto",
        "text_replace": "Substituir texto",
        "content_exclusion": "Exclusão de conteúdo",
        "url_exclusion": "Exclusão de URL",
        "ignore_inline": "Ignorar em linha",
        "unknown": "Regra desconhecida"
      }
    },
    "apply_on_content": {
      "static": "Esta regra só será aplicada a conteúdo estático.",
      "dynamic": "Esta regra só será aplicada a conteúdo dinâmico."
    }
  },
  "search_translations": {
    "title": "Gestão de pesquisas",
    "description": "Liste todas as traduções do seu site utilizadas em formulários de pesquisa (do idioma traduzido para o idioma base do seu domínio)",
    "filter_languages": "Filtrar por idiomas...",
    "filter_original": "Filtrar texto no idioma original",
    "filter_translation": "Filtrar por texto traduzido",
    "table": {
      "original": "Original",
      "language": "Idioma",
      "translation": "Tradução"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Falha na subscrição!",
      "title": "Falha na subscrição!",
      "subtitle": "Ocorreu um erro ao tentar processar a sua subscrição.",
      "home": "Voltar ao início",
      "generic": "Ocorreu um erro desconhecido do lado da Linguise; por favor, contacte o administrador!"
    },
    "success": {
      "home": "Gerir traduções do domínio",
      "message": "Comprometemo-nos a oferecer-lhe a melhor experiência de tradução possível. A nossa equipa de especialistas está disponível para o ajudar com quaisquer questões ou suporte de que possa necessitar. Para começar, clique simplesmente no botão abaixo.",
      "subtitle": "Obrigado por escolher o serviço de tradução Linguise",
      "title": "Subscrição ativada!",
      "tab_title": "Obrigado pela subscrição!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Subscrição ativada!",
      "title": "Subscrição ativada!",
      "subtitle": "Obrigado por escolher o serviço de tradução Linguise",
      "message": "'Comprometemo-nos a oferecer-lhe a melhor experiência de tradução possível. A nossa equipa de especialistas está disponível para o ajudar com quaisquer questões ou suporte de que possa necessitar. Para começar, clique simplesmente no botão abaixo.",
      "home": "Gerir traduções do domínio"
    },
    "edit": {
      "title": "Gerir subscrição"
    },
    "list": {
      "title": "Lista de subscrições",
      "description": "Lista das subscrições do seu domínio"
    },
    "table": {
      "domain": "Domínio",
      "plan": "Plano",
      "status": "Estado",
      "card": "Cartão",
      "usage": "Utilização",
      "actions": "Ações",
      "payment_method": "Método de pagamento"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} palavras",
      "paidOffered": "{{words_used}} / {{words_allowed}} palavras\n(Incluídas {{free_words}} palavras oferecidas)"
    },
    "popup": {
      "dueToday": "Total devido hoje",
      "nextPeriod": "A partir de {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Escolha uma conta"
    }
  },
  "translation": {
    "main": {
      "parent": "Traduções",
      "edit": "Editar tradução"
    },
    "form": {
      "original": {
        "title": "Original em {{language}}"
      },
      "is_inline": "Esta tradução foi feita a partir de conteúdo em linha.",
      "inline_editor": {
        "count_warning": "O número de áreas em linha não corresponde ao original ({{current}} de {{expected}}).",
        "restore_original": "Restaurar texto original",
        "insert_placeholder": "Inserir marcador de posição",
        "drag": "Arraste para reordenar a área",
        "area": "Área inline {{index}}",
        "restore": "Restaurar áreas em linha em falta"
      },
      "translation": {
        "title": "Tradução em {{language}}",
        "description": "Tradução que pretende substituir"
      }
    },
    "copy": {
      "title": "Copiar para a tradução manual",
      "label": "Copiar para manual"
    },
    "level": {
      "base": {
        "title": "Tradução base",
        "subtitle": "Automática · Tradução Linguise Cloud",
        "empty": "Não há tradução base para este texto.",
        "overridden": "Sua escolha foi salva, mas a tradução aprimorada por IA mais recente é exibida no lugar dela porque “Substituir traduções manuais e selecionadas” está como Sim nas configurações de Tradução por IA. Desative essa configuração para usar sua escolha."
      },
      "not_generated": "Não gerada",
      "none": "Nada ainda",
      "ai": {
        "title": "Tradução aprimorada por IA",
        "subtitle": "Automática · Linguise AI",
        "empty_title": "Ainda não gerada para este texto",
        "empty_description": "O Linguise AI gera traduções mais naturais usando o contexto da sua página e do seu site. Para obter uma aqui:",
        "empty_step_1": "Acesse Tradução por IA › Configurações e defina Ativar tradução por IA como “Apenas regras”, “Somente editor ao vivo” ou “Regras e editor ao vivo”.",
        "empty_step_2": "Aplique-a com uma regra que corresponda a esta página ou ative-a página por página no Editor ao Vivo.",
        "empty_step_3": "A tradução aprimorada por IA aparecerá aqui depois de gerada. Ela consome seus créditos de IA.",
        "open_settings": "Abrir configurações de Tradução por IA",
        "open_editor": "Abrir o Editor ao Vivo",
        "overrides_selection": "Sua escolha foi salva, mas esta tradução aprimorada por IA é exibida no lugar dela porque “Substituir traduções manuais e selecionadas” está como Sim nas configurações de Tradução por IA. Desative essa configuração para usar sua escolha.",
        "overrides_version": "A versão que você escolheu foi salva, mas a versão aprimorada por IA mais recente é exibida no lugar dela porque “Substituir traduções manuais e selecionadas” está como Sim nas configurações de Tradução por IA. Desative essa configuração para usar a versão escolhida."
      },
      "manual": {
        "title": "Tradução manual",
        "subtitle": "Escrita por você · tem prioridade sobre as traduções automáticas",
        "empty": "Vazia",
        "saved_but_overridden": "Salva como sua escolha, mas não exibida automaticamente porque “Substituir traduções manuais” está como Sim nas configurações de Tradução por IA: a tradução aprimorada por IA prevalece até que essa configuração seja desativada.",
        "ignored": "Não exibida automaticamente porque “Substituir traduções manuais” está como Sim nas configurações de Tradução por IA. Selecione-a para usá-la neste texto.",
        "label": "Sua tradução",
        "placeholder": "Digite sua própria tradução...",
        "last_updated": "Última edição em {{date}}",
        "save_hint": "Ao salvar uma tradução manual, ela se torna ativa.",
        "delete": "Excluir tradução manual",
        "delete_confirm": "Por favor, confirme a exclusão da tradução manual"
      }
    },
    "history": {
      "title": "Versões aprimoradas por IA",
      "subtitle": "Cada regeneração feita no Editor ao Vivo é mantida",
      "unknown_model": "Modelo desconhecido",
      "current": "Atual",
      "restore": "Restaurar esta versão",
      "restore_note": "Ao restaurar, essa versão passa a ser a tradução aprimorada por IA atual. Nada é excluído.",
      "version_of": "Versão {{current}} de {{total}}",
      "hide": "Ocultar histórico ({{total}})",
      "show": "Mostrar histórico ({{total}})"
    },
    "choose": {
      "title": "Traduções em {{language}} · escolha a que os visitantes veem",
      "current": "Atualmente no seu site:",
      "priority": "Prioridade padrão: Manual › Aprimorada por IA › Base. Sua escolha é salva apenas para esta tradução.",
      "reset": "Restaurar a prioridade padrão",
      "reset_title": "Esquecer a sua escolha para este texto e voltar a usar a prioridade padrão",
      "resetting": "Restaurando ..."
    }
  },
  "translations": {
    "title": "Gestão de traduções",
    "description": "Liste e edite todas as traduções do seu site; para uma tradução visual, use o Live Editor",
    "filter_languages": "Filtrar por idiomas...",
    "filter_original": "Filtrar texto no idioma original",
    "filter_translation": "Filtrar por texto traduzido",
    "table": {
      "original": "Original",
      "language": "Idioma",
      "action": "Ação",
      "base": "Base",
      "ai": "Aprimorada por IA",
      "manual": "Manual"
    },
    "filter_exact": "Correspondência exata",
    "badge": {
      "active": "Ativa",
      "overrides_manual": "Substitui manual"
    },
    "cell": {
      "none": "nenhuma",
      "not_generated": "não gerada",
      "ignored": "Ignorada – regra de IA prevalece"
    },
    "tabs": {
      "all": "Todas",
      "manual": "Com manual",
      "ai": "Com IA aprimorada",
      "base": "Só base"
    },
    "levels_hint": "Cada texto tem até 3 níveis — o marcado como Ativa é o que os visitantes veem."
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "Editar tradução de URL"
    },
    "form": {
      "original": {
        "title": "Original em {{language}}"
      },
      "translation": {
        "title": "Tradução de URL em {{language}}",
        "description": "URL que pretende substituir",
        "placeholder": "Substituição de tradução de URL",
        "invalid_full": "Está a tentar alterar com um formato incorreto; deve alterar apenas os slugs/pathname da tradução de URL",
        "invalid": "URL/caminho inválido fornecido"
      }
    }
  },
  "urls": {
    "title": "Gestão de URLs",
    "description": "Liste e edite todo o conteúdo traduzido de URLs do seu site (avançado; cuidado com erros 404)",
    "filter_languages": "Filtrar por idiomas...",
    "filter_original": "Filtrar texto no idioma original",
    "filter_translation": "Filtrar por texto traduzido",
    "table": {
      "original": "Original",
      "language": "Idioma",
      "url": "URL Traduzida",
      "action": "Ação",
      "edited": "A tradução original foi editada"
    }
  }
}
